import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import NewsPage from './news/NewsPage';
import JobsLayout from './jobs/JobsLayout';
import MusicLayout from './music/MusicLayout';
import HomePage from './home/HomePage';
import MusicPlayer from './music/MusicPlayer';
import { PlayerProvider } from './music/PlayerContext';

function AppInner() {
  const navigate = useNavigate();
  const location = useLocation();

  const [jobIndustryFilter, setJobIndustryFilter] = useState([]);
  const [jobRoleFilter, setJobRoleFilter] = useState([]);

  const handleNavigateToJobs = (filters = {}) => {
    setJobIndustryFilter(filters.industries || []);
    setJobRoleFilter(filters.roles || []);
    navigate('/jobs/roles');
  };

  const handleNavigateToPaper = (section) => {
    navigate(section ? `/paper/${section}` : '/paper');
  };

  return (
    <div className="App">
      <MusicPlayer />
      <nav className="app-tabs">
        <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
        <NavLink
          to="/jobs"
          className={location.pathname.startsWith('/jobs') ? 'active' : ''}
          onClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }}
        >Jobs</NavLink>
        <NavLink
          to="/music/playlist"
          className={location.pathname.startsWith('/music') ? 'active' : ''}
        >Playlist</NavLink>
        <NavLink to="/paper/stories" className={() => location.pathname.startsWith('/paper') ? 'active' : ''}>The Paper</NavLink>
      </nav>

      <Routes>
        <Route path="/" element={
          <HomePage
            onNavigateToJobs={handleNavigateToJobs}
            onNavigateToPaper={handleNavigateToPaper}
          />
        } />

        <Route path="/jobs/*" element={
          <JobsLayout
            selectedIndustries={jobIndustryFilter}
            setSelectedIndustries={setJobIndustryFilter}
            selectedRoles={jobRoleFilter}
            setSelectedRoles={setJobRoleFilter}
          />
        } />

        <Route path="/music/*" element={<MusicLayout />} />

        <Route path="/paper"                    element={<Navigate to="/paper/stories" replace />} />
        <Route path="/paper/:section"          element={<NewsPage />} />
        <Route path="/paper/:section/:article" element={<NewsPage />} />

        <Route path="*" element={
          <HomePage
            onNavigateToJobs={handleNavigateToJobs}
            onNavigateToPaper={handleNavigateToPaper}
          />
        } />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <PlayerProvider>
        <AppInner />
      </PlayerProvider>
    </BrowserRouter>
  );
}

export default App;
